import { Report } from '../../types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const reportsService = {
  list: async (siteId: string, isAdminOnly?: boolean): Promise<Report[]> => {
    const response = await apiClient.get(ENDPOINTS.reports.list(siteId, isAdminOnly))
    return response.data
  },
}

export const favoriteReportsService = {
  list: async (siteId: string): Promise<Report[]> => {
    const response = await apiClient.get(ENDPOINTS.reports.favorites.list(siteId))
    return response.data
  },

  add: (siteId: string, reportId: string) => {
    return apiClient.post(ENDPOINTS.reports.favorites.add(siteId, reportId))
  },

  remove: (siteId: string, reportId: string) => {
    return apiClient.delete(ENDPOINTS.reports.favorites.remove(siteId, reportId))
  },
}
